import type { EmblaCarouselType } from '../vendor/embla-carousel';

export const scrollBy = (
  api: EmblaCarouselType,
  distance: number,
): void => {
  const engine = api.internalEngine();
  // Invert the distance so scrolling directions match user interactions and
  // apply Embla's base friction and duration for programmatic scrolling.
  engine.scrollBody.useBaseFriction().useDuration(engine.options.duration);
  engine.scrollTo.distance(-distance, false);
};

export const scrollProgress = (api: EmblaCarouselType): number => {
  const engine = api.internalEngine();
  return engine.scrollProgress.get(engine.location.get());
};

